// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__EXE2-","item":"PaymentsMobile_item__3clAk","label":"PaymentsMobile_label__3swe8","amount":"PaymentsMobile_amount__3fD6I"};